export const menuList_Academic = [
    "node/11328837806", // FAH
    "node/11675123416", // FBA
    "node/11675123417", // FED
    "node/11675045174", // FHS
    "node/11675123418", // FLL
    "node/11675123415", // FST
    "node/11379224679", // FSS
    "node/11285379926", // HC
    "node/11381015869", // IASHSS
    "node/11285365841", // IAPME
    "node/11285446604", // ICMS
    "node/11380977674", // ICI
    "node/11380948651", // IME
    "node/11380983957", // SPO
    "node/11379244162", // The Institute for the Study of Commercial Gaming
    "node/11379218816", // Asia-Pacific Academy of Economics and Management
    "node/11379256150", // Business Research and Training Center
    "node/11380967121", // Centre for Arts and Design
    "node/11381011008", // Centre for Chinese History and Culture
    "node/11380980144", // Units - Centre for Continuing Education
    "node/11381005337", // Units - Centre for Engineering Research and Testing
    "node/11381017680", // Units - Centre for Macau Studies
    "node/11381003339", // Units - English Language Centre
    "node/11521390235", // Units - Graduate School
    "node/11381015226", // SKL-AMSV
    "node/11381018978", // SKL-IOT
    "node/11381015227", // SKL-QRCM            
  ];
export const menuList_Administrative = [
    "node/11393744116", // AAO
    "node/11399335703", // ICTO-ACTS
    "node/11299554350", // FO-AS
    "node/11521352599", // ADO
    "node/11350152382", // FO-Budget
    "node/11393744117", // CMDO
    "node/11393744118", // CSS
    "node/11399335704", // CTLE
    "node/11393744119", // CO
    "node/11393744120", // CMDO-CFM
    "node/11393744121", // CMDO-EMS
    "node/11393744122", // FO
    "node/11393744123", // GAO
    "node/11393744124", // HRS
    "node/12900954985", // IAO
    "node/11393744125", // ICTO
    "node/11393744126", // ICTO-IMS
    "node/11399335705", // ICTO-IUS
    "node/11399326913", // LIB-LRDS
    "node/11399326914", // LIB-Outreach
    "node/11399363817", // ADMO
    "node/11399363818", // HSEO
    "node/11399375127", // OSA
    "node/11399375128", // FO-Procurement
    "node/11399375129", // CO-PRS
    "node/11399375130", // PCT
    "node/11399375131", // RTO
    "node/11399375132", // REG
    "node/11542069552", // Research Services and Knowledge Transfer Office
    "node/11399375133", // CMDO-SFS
    "node/11399375134", // SAO
    "node/11399375135", // SAO-SCS
    "node/11399375136", // SAO-SDS
    "node/11399375137", // SAO-SRS
    "node/11399359299", // FO-TRE
    "node/11399359300", // UCO                       
    "way/241702236", // LIB 
    "node/11149695110", // Health Care Service    
  ];
export const menuList_Printing = [
    // FollowYou
    "node/11418968235", // E2 GF
    "node/11419056263", // E2 3F
    "node/11668687169", // E6 2F
    "node/11330274247", // E6 3F
    "node/11419061926", // E6 G111i
    "node/11530162180", // E6 1091a
    // MacauPass
    "node/11418968235", // E2 GF
    "node/11668687169", // E2 1F
    "node/11419056263", // E2 3F
    "node/11419077825", // E12 GF
    "node/11418920580", // E11 Learning Commons  
    "node/11419087664", // E21A Learning Commons
    "node/11418977599", // E21B 1F
    "node/11419061527", // E22 GF  
    "node/11418920581", // E32 Learning Commons
    "node/11419079924", // E33 1F
    "node/11419061926", // E6 G111i 
  ];
export const menuList_Parking = [
    "node/2931449477", // P1
    "way/1112207335", // P1A
    "node/2931449457", // P2
    "node/2931449461", // P3
    "node/2931448428", // P4
    "node/2931448405", // P5A
    "node/11936659985", // P5B
    "node/7619085100", // P6
    "node/2931446524", // P7      
  ];
export const menuList_ResidentialCollege = [
    "way/289598402", // CKPC
    "way/289598421", // CYTC
    "way/289598364", // CKLC
    "way/289598418", // CKYC
    "way/289598422", // HFPJC
    "way/289598373", // LCWC
    "way/289598363", // MMK-LPSC
    "way/289598404", // MCMC
    "way/289598417", // SPC
    "way/289598365", // SHEAC
    //"way/289598361", // Temporary Hostel W31
    //"way/289598362", // Temporary Hostel W32
  ];
export const menuList_BusStop = [
    
    // Public Bus
    "node/3396928056",  // T550/1
    "node/2597928921",  // T550/2
    "node/11236669768", // T550/3
    "node/3376142625",  // T550/4
    "node/2492640348", // T551
    "node/2561573383", // T552
    "node/2561573384", // T553
    "node/2597928922", // T554
    "node/2597928920", // T555
    "node/2929238176", // T556
    "node/12905463213", // T557
    "node/2597928924", // T558
    "node/2492714502", // T559      
    
    // Campus Shuttle Bus
    "node/11530209502", // #1
    "node/11530195016", // #2
    "node/11530180107", // #3
    "node/11530214723", // #4
    "node/11530199273", // #5
    "node/11530180131", // #6
    "node/11530160257", // #7
    "node/11530223580", // #8      
  ];
export const menuList_LivingQuater = [
    
    // Staff Quarter
    "way/289598391", // S21
    "way/289598395", // S22
    "way/289598393", // S23
    "way/289598399", // S24
    "way/289598396", // S25
    "way/289598398", // S26
    "way/289598392", // S27
    "way/289598397", // S28
    "way/289598394", // S29
    "way/289598390", // S30
    //"way/289598385", // S31
    //"way/289598387", // S32
    "way/289598386", // S33
    "way/289598389", // S34
    "way/289598388", // S35

    // Postgraduates House
    "way/289598407", // S1
    "way/289598409", // S2
    "way/289598408", // S3
    "way/289598410", // S4 
  ];
export const menuList_Restaurant = [
    // Dining Outlets
    "node/3048670121", // Grand Plaza
    "node/11295472303", // Eysee Bakery 
    "node/10556610977", // Azucar
    "node/2931448635", // Cafe Rose Garden 
    "node/2948030377", // Next Kitchen
    "node/11372891127", // Kou Fu Food Court
    "node/11372920671", // Siu Gwan Gon
    "node/10920886495", // Subway
    "node/2931447451", // Padaria da Guia        
    "node/12714939737", // Chopsticks
    "node/12780222126", // McDonald's    
  ];
export const menuList_Outlet = [
    // Retail Shops
    "node/2931447460", // Luen Fung Supermarket
    "node/12714946418", // The K Style
    "node/2931447429", // CITS (Macao) Travel Agency
    "node/3048670120", // U-Tech        
    "node/3016306583", // Excel      
    "node/10920886498", // Circle K (N22)
    "node/3379489559", // Circle K (S24)
    "node/11672019717", // 7-Eleven (E6)      
    "node/11671987788", // Plaza Cultural Macau
    "node/11671916297", // Renabee Logistics
  ];
export const menuList_OtherFacilities = [
    
    "node/11149695110", // Medical Center
    "node/12905374397", // Security Centre
    "node/4071460691",  // Post Office   
    
    // Banks
    "node/11162232236", // BNU
    "node/3290013561", // BOC
    "node/11365426820", // TaiFung      
    
    // ATM
    "node/11418768723", // E11-BCM
    "node/11418976779", // E2-BOC
    "node/11419002045", // E3-BOC 
    "node/11418920578", // E6-BNU
    "node/11418967685", // N6-BOC
    "node/11162232236", // N1-BNU      
  ];

export const menuList_SportFacilities = [
    
    // Top
    "way/262650944", // Sports Complex (N8)
    "way/288151233", // UM Stadium

    // Facilities
    "way/296744844",      // Archery Range
    "way/296744854",      // Beach Court
    "way/1203850127",     // Lawn Bowling Green
    "way/296744847",      // Mini Artificial Turf Soccer Pitch
    "way/1203853311",     // Volleyball Court
    "node/7618120966",    // Swimming Pool

    // Outdoor Basketball Court
    "way/1203853307", //	Outdoor Basketball Court #1
    "way/1203853308", //	Outdoor Basketball Court #2
    "way/1203849268", //	Outdoor Basketball Court #3
    "way/1203849269", //	Outdoor Basketball Court #4
    "way/1203849270", //	Outdoor Basketball Court #5
    "way/296744849", //	Outdoor Basketball Court #6
    "way/1203849261", //	Outdoor Basketball Court #7
    "way/1203849266", //	Outdoor Basketball Court #8
    "way/1203849267", //	Outdoor Basketball Court #9
    "way/1203850125", //	Outdoor Basketball Court #10
    "way/827774634", //	Outdoor Basketball Court #11
    "way/827774635", //	Outdoor Basketball Court #12
    "way/1203850122", //	Outdoor Basketball Court #13
    "way/1203850123", //	Outdoor Basketball Court #14

    // Tennis Court
    "way/1203853304", //	Tennis Court #1
    "way/1203853305", //	Tennis Court #2
    "way/1203853306", //	Tennis Court #3
    "way/1203849263", //	Tennis Court #4
    "way/1203849264", //	Tennis Court #5
    "way/1203849265", //	Tennis Court #6
    "way/656124519",  //	Tennis Court #7
    "way/656124520",  //	Tennis Court #8
    "way/656124521",  //	Tennis Court #9
    "way/1203853303", //  Tennis Practice Court
  ];
